module.exports = __webpack_public_path__ + "img/task.0833a3d2.svg";